// modal element:

if (!customElements.get('fw-pdp-modal')) {
    customElements.define('fw-pdp-modal', class ForeverWearModal extends ModalDialog {
      constructor() {
        super();
      }
  
      hide() {
        super.hide();
      }
  
      show() {
        super.show();
      }
    });
}

// modal trigger

$('#fw-checkbox').on('change', function(event) {
    if (!$('#fw-checkbox').prop('checked')) {
        let modal = document.querySelector('#fw-pdp-modal');
        if (modal) {
            modal.show();
        }
    }
    console.log('fw checkbox input change?', $('#fw-checkbox').prop('checked'));
})

// modal clicks

$('#fw-pdp-modal').on('click', '.fw-pdp-modal-close', function(event) {
    let modal = document.querySelector('#fw-pdp-modal');
    if (modal) {
        modal.hide();
    }
})

$('#fw-pdp-modal').on('click', '.fw-pdp-modal-atc', function(event) {

    let modal = document.querySelector('#fw-pdp-modal');
    if (modal) {
        modal.hide();
    }

    let product_id = $('.product-form__buttons').attr('data-variant-id');

    let formData = {
        'items': [{
         'id': parseInt(product_id),
         'quantity': 1
         }]
    };

    formData['items'].push({
        'id': 44339653083189,
        'quantity': 1
    });

    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(formData)
    }).then(function () {
        console.log('FW ATC Success!');
    });
})


// primary atc click

$('body').on('click', '#productAddToCart', function(event) {

    // let quantity = $('.product__quantity-buy-buttons').find('input[name="quantity"]').val();
    let product_id = $('.product-form__buttons').attr('data-variant-id');

    // console.log('quantity?', quantity, typeof quantity);
    // console.log('product_id?', product_id, typeof product_id);

    let formData = {
        'items': [{
         'id': parseInt(product_id),
         'quantity': 1
         }]
    };

    if ($('#fw-checkbox').prop('checked')) {
        formData['items'].push({
            'id': 44339653083189,
            'quantity': 1
        })
    }

    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(formData)
    }).then(function () {
        console.log('FW ATC Success!');
    });

});